import type { DashboardFeatureConfig } from '../../types/features/DashboardFeatureConfig';

export const dashboard: DashboardFeatureConfig = {
    showContractNumber: false,
    showCurrentInstallment: true,
    showRemainingTerm: true,
    showAmountToPay: false,
};
